// extracted by mini-css-extract-plugin
export default {"wrapper":"workstation-edit-modal_wrapper__2ujmw","tooltip":"workstation-edit-modal_tooltip__Qpl8P","table":"workstation-edit-modal_table__pfGWp"};